/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/CorporateStructureLink', 'model/DashboardPageBlockBubbleSettings', 'model/DashboardPageBlockCartesianSerieReport', 'model/DashboardPageBlockCommentPaginationSlice', 'model/DashboardPageBlockComparisonBarSerie', 'model/DashboardPageBlockComparisonColumnSerie', 'model/DashboardPageBlockCustomTableColumn', 'model/DashboardPageBlockCustomTableQuery', 'model/DashboardPageBlockExternalSettings', 'model/DashboardPageBlockGoogleSheetSettings', 'model/DashboardPageBlockMarketOverviewSettings', 'model/DashboardPageBlockMilestone', 'model/DashboardPageBlockNewsfeed', 'model/DashboardPageBlockNumberSerie', 'model/DashboardPageBlockPieSerie', 'model/DashboardPageBlockPollSettings', 'model/DashboardPageBlockPowerBIEmbed', 'model/DashboardPageBlockSolidGaugeSerie', 'model/DashboardPageBlockStrategicAction', 'model/DashboardPageBlockStrategy', 'model/DashboardPageBlockTableComparisonColumn', 'model/DashboardPageBlockTableComparisonRow', 'model/DashboardPageBlockTableDataColumn', 'model/DashboardPageBlockTableEmptyRow', 'model/DashboardPageBlockTableRollingComparison', 'model/DashboardPageBlockTableSerieRowReport', 'model/DashboardPageBlockTableSumColumn'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./CorporateStructureLink'), require('./DashboardPageBlockBubbleSettings'), require('./DashboardPageBlockCartesianSerieReport'), require('./DashboardPageBlockCommentPaginationSlice'), require('./DashboardPageBlockComparisonBarSerie'), require('./DashboardPageBlockComparisonColumnSerie'), require('./DashboardPageBlockCustomTableColumn'), require('./DashboardPageBlockCustomTableQuery'), require('./DashboardPageBlockExternalSettings'), require('./DashboardPageBlockGoogleSheetSettings'), require('./DashboardPageBlockMarketOverviewSettings'), require('./DashboardPageBlockMilestone'), require('./DashboardPageBlockNewsfeed'), require('./DashboardPageBlockNumberSerie'), require('./DashboardPageBlockPieSerie'), require('./DashboardPageBlockPollSettings'), require('./DashboardPageBlockPowerBIEmbed'), require('./DashboardPageBlockSolidGaugeSerie'), require('./DashboardPageBlockStrategicAction'), require('./DashboardPageBlockStrategy'), require('./DashboardPageBlockTableComparisonColumn'), require('./DashboardPageBlockTableComparisonRow'), require('./DashboardPageBlockTableDataColumn'), require('./DashboardPageBlockTableEmptyRow'), require('./DashboardPageBlockTableRollingComparison'), require('./DashboardPageBlockTableSerieRowReport'), require('./DashboardPageBlockTableSumColumn'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.DashboardPageBlockReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.CorporateStructureLink, root.ForStractionServiceApi.DashboardPageBlockBubbleSettings, root.ForStractionServiceApi.DashboardPageBlockCartesianSerieReport, root.ForStractionServiceApi.DashboardPageBlockCommentPaginationSlice, root.ForStractionServiceApi.DashboardPageBlockComparisonBarSerie, root.ForStractionServiceApi.DashboardPageBlockComparisonColumnSerie, root.ForStractionServiceApi.DashboardPageBlockCustomTableColumn, root.ForStractionServiceApi.DashboardPageBlockCustomTableQuery, root.ForStractionServiceApi.DashboardPageBlockExternalSettings, root.ForStractionServiceApi.DashboardPageBlockGoogleSheetSettings, root.ForStractionServiceApi.DashboardPageBlockMarketOverviewSettings, root.ForStractionServiceApi.DashboardPageBlockMilestone, root.ForStractionServiceApi.DashboardPageBlockNewsfeed, root.ForStractionServiceApi.DashboardPageBlockNumberSerie, root.ForStractionServiceApi.DashboardPageBlockPieSerie, root.ForStractionServiceApi.DashboardPageBlockPollSettings, root.ForStractionServiceApi.DashboardPageBlockPowerBIEmbed, root.ForStractionServiceApi.DashboardPageBlockSolidGaugeSerie, root.ForStractionServiceApi.DashboardPageBlockStrategicAction, root.ForStractionServiceApi.DashboardPageBlockStrategy, root.ForStractionServiceApi.DashboardPageBlockTableComparisonColumn, root.ForStractionServiceApi.DashboardPageBlockTableComparisonRow, root.ForStractionServiceApi.DashboardPageBlockTableDataColumn, root.ForStractionServiceApi.DashboardPageBlockTableEmptyRow, root.ForStractionServiceApi.DashboardPageBlockTableRollingComparison, root.ForStractionServiceApi.DashboardPageBlockTableSerieRowReport, root.ForStractionServiceApi.DashboardPageBlockTableSumColumn);
  }
}(this, function(ApiClient, CorporateStructureLink, DashboardPageBlockBubbleSettings, DashboardPageBlockCartesianSerieReport, DashboardPageBlockCommentPaginationSlice, DashboardPageBlockComparisonBarSerie, DashboardPageBlockComparisonColumnSerie, DashboardPageBlockCustomTableColumn, DashboardPageBlockCustomTableQuery, DashboardPageBlockExternalSettings, DashboardPageBlockGoogleSheetSettings, DashboardPageBlockMarketOverviewSettings, DashboardPageBlockMilestone, DashboardPageBlockNewsfeed, DashboardPageBlockNumberSerie, DashboardPageBlockPieSerie, DashboardPageBlockPollSettings, DashboardPageBlockPowerBIEmbed, DashboardPageBlockSolidGaugeSerie, DashboardPageBlockStrategicAction, DashboardPageBlockStrategy, DashboardPageBlockTableComparisonColumn, DashboardPageBlockTableComparisonRow, DashboardPageBlockTableDataColumn, DashboardPageBlockTableEmptyRow, DashboardPageBlockTableRollingComparison, DashboardPageBlockTableSerieRowReport, DashboardPageBlockTableSumColumn) {
  'use strict';




  /**
   * The DashboardPageBlockReport model module.
   * @module model/DashboardPageBlockReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>DashboardPageBlockReport</code>.
   * @alias module:model/DashboardPageBlockReport
   * @class
   */
  var exports = function() {
    var _this = this;














































































  };

  /**
   * Constructs a <code>DashboardPageBlockReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DashboardPageBlockReport} obj Optional instance to populate.
   * @return {module:model/DashboardPageBlockReport} The populated <code>DashboardPageBlockReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Comments')) {
        obj['Comments'] = DashboardPageBlockCommentPaginationSlice.constructFromObject(data['Comments']);
      }
      if (data.hasOwnProperty('CartesianSeries')) {
        obj['CartesianSeries'] = ApiClient.convertToType(data['CartesianSeries'], [DashboardPageBlockCartesianSerieReport]);
      }
      if (data.hasOwnProperty('ComparisonColumnSeries')) {
        obj['ComparisonColumnSeries'] = ApiClient.convertToType(data['ComparisonColumnSeries'], [DashboardPageBlockComparisonColumnSerie]);
      }
      if (data.hasOwnProperty('ComparisonBarSeries')) {
        obj['ComparisonBarSeries'] = ApiClient.convertToType(data['ComparisonBarSeries'], [DashboardPageBlockComparisonBarSerie]);
      }
      if (data.hasOwnProperty('Newsfeed')) {
        obj['Newsfeed'] = DashboardPageBlockNewsfeed.constructFromObject(data['Newsfeed']);
      }
      if (data.hasOwnProperty('PieSeries')) {
        obj['PieSeries'] = ApiClient.convertToType(data['PieSeries'], [DashboardPageBlockPieSerie]);
      }
      if (data.hasOwnProperty('NumberSeries')) {
        obj['NumberSeries'] = ApiClient.convertToType(data['NumberSeries'], [DashboardPageBlockNumberSerie]);
      }
      if (data.hasOwnProperty('SolidGaugeSeries')) {
        obj['SolidGaugeSeries'] = ApiClient.convertToType(data['SolidGaugeSeries'], [DashboardPageBlockSolidGaugeSerie]);
      }
      if (data.hasOwnProperty('StrategicAction')) {
        obj['StrategicAction'] = DashboardPageBlockStrategicAction.constructFromObject(data['StrategicAction']);
      }
      if (data.hasOwnProperty('ExternalSettings')) {
        obj['ExternalSettings'] = DashboardPageBlockExternalSettings.constructFromObject(data['ExternalSettings']);
      }
      if (data.hasOwnProperty('MarketOverviewSettings')) {
        obj['MarketOverviewSettings'] = DashboardPageBlockMarketOverviewSettings.constructFromObject(data['MarketOverviewSettings']);
      }
      if (data.hasOwnProperty('PollSettings')) {
        obj['PollSettings'] = DashboardPageBlockPollSettings.constructFromObject(data['PollSettings']);
      }
      if (data.hasOwnProperty('TableRollingComparisons')) {
        obj['TableRollingComparisons'] = ApiClient.convertToType(data['TableRollingComparisons'], [DashboardPageBlockTableRollingComparison]);
      }
      if (data.hasOwnProperty('TableDataColumns')) {
        obj['TableDataColumns'] = ApiClient.convertToType(data['TableDataColumns'], [DashboardPageBlockTableDataColumn]);
      }
      if (data.hasOwnProperty('TableComparisonColumns')) {
        obj['TableComparisonColumns'] = ApiClient.convertToType(data['TableComparisonColumns'], [DashboardPageBlockTableComparisonColumn]);
      }
      if (data.hasOwnProperty('TableSumColumns')) {
        obj['TableSumColumns'] = ApiClient.convertToType(data['TableSumColumns'], [DashboardPageBlockTableSumColumn]);
      }
      if (data.hasOwnProperty('TableSerieRows')) {
        obj['TableSerieRows'] = ApiClient.convertToType(data['TableSerieRows'], [DashboardPageBlockTableSerieRowReport]);
      }
      if (data.hasOwnProperty('TableComparisonRows')) {
        obj['TableComparisonRows'] = ApiClient.convertToType(data['TableComparisonRows'], [DashboardPageBlockTableComparisonRow]);
      }
      if (data.hasOwnProperty('TableEmptyRows')) {
        obj['TableEmptyRows'] = ApiClient.convertToType(data['TableEmptyRows'], [DashboardPageBlockTableEmptyRow]);
      }
      if (data.hasOwnProperty('BubbleSettings')) {
        obj['BubbleSettings'] = DashboardPageBlockBubbleSettings.constructFromObject(data['BubbleSettings']);
      }
      if (data.hasOwnProperty('GoogleSheetSettings')) {
        obj['GoogleSheetSettings'] = DashboardPageBlockGoogleSheetSettings.constructFromObject(data['GoogleSheetSettings']);
      }
      if (data.hasOwnProperty('PowerBIEmbed')) {
        obj['PowerBIEmbed'] = DashboardPageBlockPowerBIEmbed.constructFromObject(data['PowerBIEmbed']);
      }
      if (data.hasOwnProperty('CustomTableQuery')) {
        obj['CustomTableQuery'] = DashboardPageBlockCustomTableQuery.constructFromObject(data['CustomTableQuery']);
      }
      if (data.hasOwnProperty('CustomTableColumns')) {
        obj['CustomTableColumns'] = ApiClient.convertToType(data['CustomTableColumns'], [DashboardPageBlockCustomTableColumn]);
      }
      if (data.hasOwnProperty('StrategySettings')) {
        obj['StrategySettings'] = DashboardPageBlockStrategy.constructFromObject(data['StrategySettings']);
      }
      if (data.hasOwnProperty('MilestoneSettings')) {
        obj['MilestoneSettings'] = DashboardPageBlockMilestone.constructFromObject(data['MilestoneSettings']);
      }
      if (data.hasOwnProperty('DefaultPeriodTypeID')) {
        obj['DefaultPeriodTypeID'] = ApiClient.convertToType(data['DefaultPeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('TypeID')) {
        obj['TypeID'] = ApiClient.convertToType(data['TypeID'], 'Integer');
      }
      if (data.hasOwnProperty('PageID')) {
        obj['PageID'] = ApiClient.convertToType(data['PageID'], 'Integer');
      }
      if (data.hasOwnProperty('Instruction')) {
        obj['Instruction'] = ApiClient.convertToType(data['Instruction'], 'String');
      }
      if (data.hasOwnProperty('GridXCellStart')) {
        obj['GridXCellStart'] = ApiClient.convertToType(data['GridXCellStart'], 'Integer');
      }
      if (data.hasOwnProperty('GridYCellStart')) {
        obj['GridYCellStart'] = ApiClient.convertToType(data['GridYCellStart'], 'Integer');
      }
      if (data.hasOwnProperty('WidthGridCells')) {
        obj['WidthGridCells'] = ApiClient.convertToType(data['WidthGridCells'], 'Integer');
      }
      if (data.hasOwnProperty('HeightGridCells')) {
        obj['HeightGridCells'] = ApiClient.convertToType(data['HeightGridCells'], 'Integer');
      }
      if (data.hasOwnProperty('PeriodTypeID')) {
        obj['PeriodTypeID'] = ApiClient.convertToType(data['PeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('UseLastFinancialPeriod')) {
        obj['UseLastFinancialPeriod'] = ApiClient.convertToType(data['UseLastFinancialPeriod'], 'Boolean');
      }
      if (data.hasOwnProperty('RangeStartYearOffset')) {
        obj['RangeStartYearOffset'] = ApiClient.convertToType(data['RangeStartYearOffset'], 'Integer');
      }
      if (data.hasOwnProperty('RangeStartPeriodOffset')) {
        obj['RangeStartPeriodOffset'] = ApiClient.convertToType(data['RangeStartPeriodOffset'], 'Integer');
      }
      if (data.hasOwnProperty('Range')) {
        obj['Range'] = ApiClient.convertToType(data['Range'], 'Integer');
      }
      if (data.hasOwnProperty('CustomRangePastPeriods')) {
        obj['CustomRangePastPeriods'] = ApiClient.convertToType(data['CustomRangePastPeriods'], 'Integer');
      }
      if (data.hasOwnProperty('CustomRangeFuturePeriods')) {
        obj['CustomRangeFuturePeriods'] = ApiClient.convertToType(data['CustomRangeFuturePeriods'], 'Integer');
      }
      if (data.hasOwnProperty('SerieOrder')) {
        obj['SerieOrder'] = ApiClient.convertToType(data['SerieOrder'], 'Integer');
      }
      if (data.hasOwnProperty('NumberFormat')) {
        obj['NumberFormat'] = ApiClient.convertToType(data['NumberFormat'], 'String');
      }
      if (data.hasOwnProperty('IsWaterfall')) {
        obj['IsWaterfall'] = ApiClient.convertToType(data['IsWaterfall'], 'Boolean');
      }
      if (data.hasOwnProperty('YAxisMin')) {
        obj['YAxisMin'] = ApiClient.convertToType(data['YAxisMin'], 'Number');
      }
      if (data.hasOwnProperty('YAxisMax')) {
        obj['YAxisMax'] = ApiClient.convertToType(data['YAxisMax'], 'Number');
      }
      if (data.hasOwnProperty('HasRollingTableColumns')) {
        obj['HasRollingTableColumns'] = ApiClient.convertToType(data['HasRollingTableColumns'], 'Boolean');
      }
      if (data.hasOwnProperty('RollingTableColumnsPastDimensionID')) {
        obj['RollingTableColumnsPastDimensionID'] = ApiClient.convertToType(data['RollingTableColumnsPastDimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('RollingTableColumnsAlternativePastDimensionID')) {
        obj['RollingTableColumnsAlternativePastDimensionID'] = ApiClient.convertToType(data['RollingTableColumnsAlternativePastDimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('RollingTableColumnsFutureDimensionID')) {
        obj['RollingTableColumnsFutureDimensionID'] = ApiClient.convertToType(data['RollingTableColumnsFutureDimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('RollingTableColumnsAlternativeFutureDimensionID')) {
        obj['RollingTableColumnsAlternativeFutureDimensionID'] = ApiClient.convertToType(data['RollingTableColumnsAlternativeFutureDimensionID'], 'Integer');
      }
      if (data.hasOwnProperty('RollingTableColumnsTotalEnabled')) {
        obj['RollingTableColumnsTotalEnabled'] = ApiClient.convertToType(data['RollingTableColumnsTotalEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('HasTrackingLevelRows')) {
        obj['HasTrackingLevelRows'] = ApiClient.convertToType(data['HasTrackingLevelRows'], 'Boolean');
      }
      if (data.hasOwnProperty('EmptyItemsHidden')) {
        obj['EmptyItemsHidden'] = ApiClient.convertToType(data['EmptyItemsHidden'], 'Boolean');
      }
      if (data.hasOwnProperty('TrackingLevelRowsIndicatorID')) {
        obj['TrackingLevelRowsIndicatorID'] = ApiClient.convertToType(data['TrackingLevelRowsIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('TrackingLevelRowsTrackingLevelID')) {
        obj['TrackingLevelRowsTrackingLevelID'] = ApiClient.convertToType(data['TrackingLevelRowsTrackingLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('ProductFilteringEnabled')) {
        obj['ProductFilteringEnabled'] = ApiClient.convertToType(data['ProductFilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('GeoAreaFilteringEnabled')) {
        obj['GeoAreaFilteringEnabled'] = ApiClient.convertToType(data['GeoAreaFilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('CustomerFilteringEnabled')) {
        obj['CustomerFilteringEnabled'] = ApiClient.convertToType(data['CustomerFilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('TrackingLevel1FilteringEnabled')) {
        obj['TrackingLevel1FilteringEnabled'] = ApiClient.convertToType(data['TrackingLevel1FilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('TrackingLevel2FilteringEnabled')) {
        obj['TrackingLevel2FilteringEnabled'] = ApiClient.convertToType(data['TrackingLevel2FilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('TrackingLevel3FilteringEnabled')) {
        obj['TrackingLevel3FilteringEnabled'] = ApiClient.convertToType(data['TrackingLevel3FilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('TrackingLevel4FilteringEnabled')) {
        obj['TrackingLevel4FilteringEnabled'] = ApiClient.convertToType(data['TrackingLevel4FilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('CompanyLegalEntityFilteringEnabled')) {
        obj['CompanyLegalEntityFilteringEnabled'] = ApiClient.convertToType(data['CompanyLegalEntityFilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('CompanyFunctionFilteringEnabled')) {
        obj['CompanyFunctionFilteringEnabled'] = ApiClient.convertToType(data['CompanyFunctionFilteringEnabled'], 'Boolean');
      }
      if (data.hasOwnProperty('UseLastSalesPeriod')) {
        obj['UseLastSalesPeriod'] = ApiClient.convertToType(data['UseLastSalesPeriod'], 'Boolean');
      }
      if (data.hasOwnProperty('CreatorID')) {
        obj['CreatorID'] = ApiClient.convertToType(data['CreatorID'], 'Integer');
      }
      if (data.hasOwnProperty('Created')) {
        obj['Created'] = ApiClient.convertToType(data['Created'], 'Date');
      }
      if (data.hasOwnProperty('DefaultRollingTableColumnOffset')) {
        obj['DefaultRollingTableColumnOffset'] = ApiClient.convertToType(data['DefaultRollingTableColumnOffset'], 'Integer');
      }
      if (data.hasOwnProperty('ForesightScenarioID')) {
        obj['ForesightScenarioID'] = ApiClient.convertToType(data['ForesightScenarioID'], 'Integer');
      }
      if (data.hasOwnProperty('AlertID')) {
        obj['AlertID'] = ApiClient.convertToType(data['AlertID'], 'Integer');
      }
      if (data.hasOwnProperty('CorporateStructureLink')) {
        obj['CorporateStructureLink'] = CorporateStructureLink.constructFromObject(data['CorporateStructureLink']);
      }
      if (data.hasOwnProperty('NameFI')) {
        obj['NameFI'] = ApiClient.convertToType(data['NameFI'], 'String');
      }
      if (data.hasOwnProperty('NameEN')) {
        obj['NameEN'] = ApiClient.convertToType(data['NameEN'], 'String');
      }
      if (data.hasOwnProperty('NameSE')) {
        obj['NameSE'] = ApiClient.convertToType(data['NameSE'], 'String');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {module:model/DashboardPageBlockCommentPaginationSlice} Comments
   */
  exports.prototype['Comments'] = undefined;
  /**
   * @member {Array.<module:model/DashboardPageBlockCartesianSerieReport>} CartesianSeries
   */
  exports.prototype['CartesianSeries'] = undefined;
  /**
   * @member {Array.<module:model/DashboardPageBlockComparisonColumnSerie>} ComparisonColumnSeries
   */
  exports.prototype['ComparisonColumnSeries'] = undefined;
  /**
   * @member {Array.<module:model/DashboardPageBlockComparisonBarSerie>} ComparisonBarSeries
   */
  exports.prototype['ComparisonBarSeries'] = undefined;
  /**
   * @member {module:model/DashboardPageBlockNewsfeed} Newsfeed
   */
  exports.prototype['Newsfeed'] = undefined;
  /**
   * @member {Array.<module:model/DashboardPageBlockPieSerie>} PieSeries
   */
  exports.prototype['PieSeries'] = undefined;
  /**
   * @member {Array.<module:model/DashboardPageBlockNumberSerie>} NumberSeries
   */
  exports.prototype['NumberSeries'] = undefined;
  /**
   * @member {Array.<module:model/DashboardPageBlockSolidGaugeSerie>} SolidGaugeSeries
   */
  exports.prototype['SolidGaugeSeries'] = undefined;
  /**
   * @member {module:model/DashboardPageBlockStrategicAction} StrategicAction
   */
  exports.prototype['StrategicAction'] = undefined;
  /**
   * @member {module:model/DashboardPageBlockExternalSettings} ExternalSettings
   */
  exports.prototype['ExternalSettings'] = undefined;
  /**
   * @member {module:model/DashboardPageBlockMarketOverviewSettings} MarketOverviewSettings
   */
  exports.prototype['MarketOverviewSettings'] = undefined;
  /**
   * @member {module:model/DashboardPageBlockPollSettings} PollSettings
   */
  exports.prototype['PollSettings'] = undefined;
  /**
   * @member {Array.<module:model/DashboardPageBlockTableRollingComparison>} TableRollingComparisons
   */
  exports.prototype['TableRollingComparisons'] = undefined;
  /**
   * @member {Array.<module:model/DashboardPageBlockTableDataColumn>} TableDataColumns
   */
  exports.prototype['TableDataColumns'] = undefined;
  /**
   * @member {Array.<module:model/DashboardPageBlockTableComparisonColumn>} TableComparisonColumns
   */
  exports.prototype['TableComparisonColumns'] = undefined;
  /**
   * @member {Array.<module:model/DashboardPageBlockTableSumColumn>} TableSumColumns
   */
  exports.prototype['TableSumColumns'] = undefined;
  /**
   * @member {Array.<module:model/DashboardPageBlockTableSerieRowReport>} TableSerieRows
   */
  exports.prototype['TableSerieRows'] = undefined;
  /**
   * @member {Array.<module:model/DashboardPageBlockTableComparisonRow>} TableComparisonRows
   */
  exports.prototype['TableComparisonRows'] = undefined;
  /**
   * @member {Array.<module:model/DashboardPageBlockTableEmptyRow>} TableEmptyRows
   */
  exports.prototype['TableEmptyRows'] = undefined;
  /**
   * @member {module:model/DashboardPageBlockBubbleSettings} BubbleSettings
   */
  exports.prototype['BubbleSettings'] = undefined;
  /**
   * @member {module:model/DashboardPageBlockGoogleSheetSettings} GoogleSheetSettings
   */
  exports.prototype['GoogleSheetSettings'] = undefined;
  /**
   * @member {module:model/DashboardPageBlockPowerBIEmbed} PowerBIEmbed
   */
  exports.prototype['PowerBIEmbed'] = undefined;
  /**
   * @member {module:model/DashboardPageBlockCustomTableQuery} CustomTableQuery
   */
  exports.prototype['CustomTableQuery'] = undefined;
  /**
   * @member {Array.<module:model/DashboardPageBlockCustomTableColumn>} CustomTableColumns
   */
  exports.prototype['CustomTableColumns'] = undefined;
  /**
   * @member {module:model/DashboardPageBlockStrategy} StrategySettings
   */
  exports.prototype['StrategySettings'] = undefined;
  /**
   * @member {module:model/DashboardPageBlockMilestone} MilestoneSettings
   */
  exports.prototype['MilestoneSettings'] = undefined;
  /**
   * @member {Integer} DefaultPeriodTypeID
   * @default 0
   */
  exports.prototype['DefaultPeriodTypeID'] = 0;
  /**
   * @member {Integer} TypeID
   * @default 0
   */
  exports.prototype['TypeID'] = 0;
  /**
   * @member {Integer} PageID
   */
  exports.prototype['PageID'] = undefined;
  /**
   * @member {String} Instruction
   * @default ''
   */
  exports.prototype['Instruction'] = '';
  /**
   * @member {Integer} GridXCellStart
   * @default 0
   */
  exports.prototype['GridXCellStart'] = 0;
  /**
   * @member {Integer} GridYCellStart
   * @default 0
   */
  exports.prototype['GridYCellStart'] = 0;
  /**
   * @member {Integer} WidthGridCells
   * @default 0
   */
  exports.prototype['WidthGridCells'] = 0;
  /**
   * @member {Integer} HeightGridCells
   * @default 0
   */
  exports.prototype['HeightGridCells'] = 0;
  /**
   * @member {Integer} PeriodTypeID
   */
  exports.prototype['PeriodTypeID'] = undefined;
  /**
   * @member {Boolean} UseLastFinancialPeriod
   * @default false
   */
  exports.prototype['UseLastFinancialPeriod'] = false;
  /**
   * @member {Integer} RangeStartYearOffset
   */
  exports.prototype['RangeStartYearOffset'] = undefined;
  /**
   * @member {Integer} RangeStartPeriodOffset
   */
  exports.prototype['RangeStartPeriodOffset'] = undefined;
  /**
   * @member {Integer} Range
   */
  exports.prototype['Range'] = undefined;
  /**
   * @member {Integer} CustomRangePastPeriods
   */
  exports.prototype['CustomRangePastPeriods'] = undefined;
  /**
   * @member {Integer} CustomRangeFuturePeriods
   */
  exports.prototype['CustomRangeFuturePeriods'] = undefined;
  /**
   * @member {Integer} SerieOrder
   */
  exports.prototype['SerieOrder'] = undefined;
  /**
   * @member {String} NumberFormat
   * @default ''
   */
  exports.prototype['NumberFormat'] = '';
  /**
   * @member {Boolean} IsWaterfall
   * @default false
   */
  exports.prototype['IsWaterfall'] = false;
  /**
   * @member {Number} YAxisMin
   */
  exports.prototype['YAxisMin'] = undefined;
  /**
   * @member {Number} YAxisMax
   */
  exports.prototype['YAxisMax'] = undefined;
  /**
   * @member {Boolean} HasRollingTableColumns
   */
  exports.prototype['HasRollingTableColumns'] = undefined;
  /**
   * @member {Integer} RollingTableColumnsPastDimensionID
   */
  exports.prototype['RollingTableColumnsPastDimensionID'] = undefined;
  /**
   * @member {Integer} RollingTableColumnsAlternativePastDimensionID
   */
  exports.prototype['RollingTableColumnsAlternativePastDimensionID'] = undefined;
  /**
   * @member {Integer} RollingTableColumnsFutureDimensionID
   */
  exports.prototype['RollingTableColumnsFutureDimensionID'] = undefined;
  /**
   * @member {Integer} RollingTableColumnsAlternativeFutureDimensionID
   */
  exports.prototype['RollingTableColumnsAlternativeFutureDimensionID'] = undefined;
  /**
   * @member {Boolean} RollingTableColumnsTotalEnabled
   */
  exports.prototype['RollingTableColumnsTotalEnabled'] = undefined;
  /**
   * @member {Boolean} HasTrackingLevelRows
   */
  exports.prototype['HasTrackingLevelRows'] = undefined;
  /**
   * @member {Boolean} EmptyItemsHidden
   * @default false
   */
  exports.prototype['EmptyItemsHidden'] = false;
  /**
   * @member {Integer} TrackingLevelRowsIndicatorID
   */
  exports.prototype['TrackingLevelRowsIndicatorID'] = undefined;
  /**
   * @member {Integer} TrackingLevelRowsTrackingLevelID
   */
  exports.prototype['TrackingLevelRowsTrackingLevelID'] = undefined;
  /**
   * @member {Boolean} ProductFilteringEnabled
   * @default false
   */
  exports.prototype['ProductFilteringEnabled'] = false;
  /**
   * @member {Boolean} GeoAreaFilteringEnabled
   * @default false
   */
  exports.prototype['GeoAreaFilteringEnabled'] = false;
  /**
   * @member {Boolean} CustomerFilteringEnabled
   * @default false
   */
  exports.prototype['CustomerFilteringEnabled'] = false;
  /**
   * @member {Boolean} TrackingLevel1FilteringEnabled
   * @default false
   */
  exports.prototype['TrackingLevel1FilteringEnabled'] = false;
  /**
   * @member {Boolean} TrackingLevel2FilteringEnabled
   * @default false
   */
  exports.prototype['TrackingLevel2FilteringEnabled'] = false;
  /**
   * @member {Boolean} TrackingLevel3FilteringEnabled
   * @default false
   */
  exports.prototype['TrackingLevel3FilteringEnabled'] = false;
  /**
   * @member {Boolean} TrackingLevel4FilteringEnabled
   * @default false
   */
  exports.prototype['TrackingLevel4FilteringEnabled'] = false;
  /**
   * @member {Boolean} CompanyLegalEntityFilteringEnabled
   * @default false
   */
  exports.prototype['CompanyLegalEntityFilteringEnabled'] = false;
  /**
   * @member {Boolean} CompanyFunctionFilteringEnabled
   * @default false
   */
  exports.prototype['CompanyFunctionFilteringEnabled'] = false;
  /**
   * @member {Boolean} UseLastSalesPeriod
   * @default false
   */
  exports.prototype['UseLastSalesPeriod'] = false;
  /**
   * @member {Integer} CreatorID
   */
  exports.prototype['CreatorID'] = undefined;
  /**
   * @member {Date} Created
   */
  exports.prototype['Created'] = undefined;
  /**
   * @member {Integer} DefaultRollingTableColumnOffset
   * @default 0
   */
  exports.prototype['DefaultRollingTableColumnOffset'] = 0;
  /**
   * @member {Integer} ForesightScenarioID
   */
  exports.prototype['ForesightScenarioID'] = undefined;
  /**
   * @member {Integer} AlertID
   */
  exports.prototype['AlertID'] = undefined;
  /**
   * @member {module:model/CorporateStructureLink} CorporateStructureLink
   */
  exports.prototype['CorporateStructureLink'] = undefined;
  /**
   * @member {String} NameFI
   * @default ''
   */
  exports.prototype['NameFI'] = '';
  /**
   * @member {String} NameEN
   * @default ''
   */
  exports.prototype['NameEN'] = '';
  /**
   * @member {String} NameSE
   * @default ''
   */
  exports.prototype['NameSE'] = '';
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


